"use client";

import React from "react";
import { ArrowRight } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FuelYourStrengthHero() {
  const {
    ref: contentRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="75484" id="championship-hero" className="bg-background text-foreground relative min-h-[90vh] flex items-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603950/img/athlete_deadlifting_warehouse_gym.png" alt="Desaturated action shot of a softball player with pink highlight" className="w-full h-full object-cover object-center grayscale opacity-80 md:opacity-100" src="https://cj-circle.com/wp-content/uploads/2026/05/IMG_1249-scaled.jpeg" />
        {}
        <div className="absolute inset-0 bg-pink-400/30 mix-blend-color-burn md:bg-pink-300/20"></div>
      </div>

      {}
      <div className="container mx-auto px-4 md:px-6 relative z-10 py-24 md:py-32">
        <div ref={contentRef} className="max-w-5xl">
          {}
          <h1 className="font-sans font-black tracking-tighter text-6xl sm:text-7xl md:text-8xl lg:text-[10rem] uppercase leading-[0.85] flex flex-col">
            <span className={`block transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              Train
            </span>
            <span className={`block transition-all duration-1000 ease-out delay-150 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              Smarter.
            </span>
            <span className={`block text-black drop-shadow-[0_0_20px_rgba(255,192,203,0.6)] transition-all duration-1000 ease-out delay-300 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
              Play
              <br className="hidden md:block" /> <span className="text-pink-400">Harder.</span>
            </span>
          </h1>

          {}
          <p className={`mt-8 font-sans text-[20px] text-white max-w-2xl transition-all duration-1000 ease-out delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>Softball coaching for athletes who want to dominate the diamond. Build elite skills and unshakeable confidence with CJ’s Circle.</p>

          {}
          <div className={`mt-12 flex flex-col sm:flex-row flex-wrap gap-4 transition-all duration-1000 ease-out delay-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
            <Button asChild size="lg" className="w-full sm:w-[220px] h-16 text-lg font-bold uppercase tracking-wide group bg-black text-white hover:bg-pink-400 rounded-lg transition-colors duration-300">
              <Link to="/TrainingAndMembershipPage">
                Start Training
                <ArrowRight className="ml-2 size-5 transition-transform group-hover:translate-x-1" />
              </Link>
            </Button>
            
            <Button asChild variant="outline" size="lg" className="w-full sm:w-[220px] h-16 text-lg font-bold uppercase tracking-wide border-black text-black hover:bg-black hover:text-white rounded-lg transition-colors duration-300">
              <Link to="#">
                Shop Merch
              </Link>
            </Button>
            
            <Button asChild variant="secondary" size="lg" className="w-full sm:w-[220px] h-16 text-lg font-bold uppercase tracking-wide bg-pink-100/80 hover:bg-pink-200 text-black border-none backdrop-blur-md rounded-lg transition-colors duration-300">
              <Link to="/TrainingAndMembershipPage">
                View Portal
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}